import { render, staticRenderFns } from "./TakeExam2.vue?vue&type=template&id=ac754c72&lang=pug&"
import script from "./TakeExam2.vue?vue&type=script&lang=js&"
export * from "./TakeExam2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports